import moment, {duration} from 'moment';

const MILLISECONDS = 1000;

/**
 * Formats the stored milking time value into `m:ss`.
 *
 * @param value Milking time stored in seconds.
 * @returns A readable `m:ss` duration string.
 */
export const formatMilkingTime = (value: number): string =>
    moment(duration(value * MILLISECONDS).as('milliseconds')).format('m:ss');
